module.exports = __webpack_public_path__ + "static/img/2-2-4.930b0eb8.jpg";